module.exports = __webpack_public_path__ + "img/SystemCardBottomRightCorner.50fe8694.png";